import { $, $$ } from '../utils/querySelector';
import { ScrollableTabHeader } from './scrollable-tab-header';

export function scrollableTabsFactory(selector = '.ghwp-tabs--scrollable') {
    $$()(selector)?.forEach((e) => {
        const ul = $(e)('ul');
        const back = $(e)('.scroll-hint.scroll-hint--left');
        const forward = $(e)('.scroll-hint.scroll-hint--right');
        new ScrollableTabHeader(ul, back, forward);
    });
}
